import { jsx as c } from "react/jsx-runtime";
import { TableComponent as u } from "../table/table.js";
import '../../assets/QCEResults.css';const g = "_QCEResult_1qr0r_1", f = "_lightgreen_1qr0r_4", m = "_lightyellow_1qr0r_8", p = "_coral_1qr0r_12", A = "_boldtext_1qr0r_17", r = {
  QCEResult: g,
  lightgreen: f,
  lightyellow: m,
  coral: p,
  boldtext: A
}, S = ({ studentyear: o, results: h, sx: e }) => {
  const { columns: d, rows: l } = I(Number(o), h);
  return /* @__PURE__ */ c(u, { columns: d, rows: l, isPending: !1, numSticky: 1, sx: e, className: r.QCESubjects, size: "small" });
}, I = (o, h) => {
  const e = [
    { id: "Subject", header: "Subject" },
    { id: "Staffname", header: "Teacher" }
  ];
  o === 11 ? (e.push({ id: "FIA1", header: "FIA1" }), e.push({ id: "FIA2", header: "FIA2" }), e.push({ id: "Unit1", header: "Unit 1" }), e.push({ id: "FIA3", header: "FIA3" }), e.push({ id: "FIA4", header: "FIA4" }), e.push({ id: "Unit2", header: "Unit 2" })) : (e.push({ id: "IA1", header: "IA1" }), e.push({ id: "IA2", header: "IA2" }), e.push({ id: "IA3", header: "IA3" }), e.push({ id: "IA4", header: "IA4" }), e.push({ id: "Percentage", header: "Percentage" }), e.push({ id: "Grade", header: "Grade" }));
  let d = [];
  return h.forEach((l) => {
    const a = {};
    Object.entries(l).forEach(([s, t]) => {
      let i;
      if (s === "Subject" && l.StudentEnrolled && (i = `${r.boldtext}`), (s === "Unit1" || s === "Unit2") && (t === "S" ? i = `${r.lightgreen}` : t === "" ? i = void 0 : i = `${r.coral}`), s === "Percentage") {
        const n = Number(t);
        i = n >= 50 ? `${r.lightgreen}` : n < 50 && n > 39 ? `${r.lightyellow}` : n < 40 ? `${r.coral}` : void 0, t = t !== "-" ? `${t}%` : "";
      }
      s === "Grade" && (i = ["A", "B", "C"].includes(String(t)) ? `${r.lightgreen}` : t === "" || t === "-" ? void 0 : `${r.coral}`), a[s] = /* @__PURE__ */ c("div", { className: s === "Subject" || s === "Staffname" ? "" : r.QCEResult, children: /* @__PURE__ */ c("div", { className: i, children: t }) });
    }), d.push(a);
  }), { columns: e, rows: d };
};
export {
  S as QCEResultsTable
};
//# sourceMappingURL=QCEResults.js.map
